/*
 * @Author: monai
 * @Date: 2021-08-09 17:47:38
 * @LastEditors: monai
 * @LastEditTime: 2025-07-07 14:48:30
 */
import { getLanguage } from '../activityPublic';
import getProfile from '@library/JSBridgeFunction/profile';
import * as Sentry from "@sentry/vue";
import {getQueryString} from '@activity-business/h5-package-frameworkTool';
import {fnIsLowVersion, fnGetCommentInfo, fnIsJsBridgeError} from './utils';
import type {Config} from './utils';

export class Pretreatment {
    //  当前 vue 实例
    public app: any;
    public config: Config;
    //  sentry dsn 默认值
    static DEFAULT_SENTRY_DSN: string = CONFIG.sentryDSN;
    //  language country 默认值
    static DEFAULT_LANGUAGE_COUNTRY: string[] = [];
    //  默认配置项
    static DEFAULT_CONFIG: Config = {
        language: {
            use: true,
            country: Pretreatment.DEFAULT_LANGUAGE_COUNTRY
        },
        sentry: {
            use: true,
            dsn: Pretreatment.DEFAULT_SENTRY_DSN
        }
    }
    //  参数为：app, string[]，直接默认活动开发逻辑
    public constructor(app: any, config: string[]);
    //  参数为：app, Config，则为详细配置
    public constructor(app: any, config: Config);
    public constructor(app, config){
        this.app = app;
        //  活动常用方式，直接传入国家数组
        if(Array.isArray(config)){
            this.config = Object.assign(Pretreatment.DEFAULT_CONFIG, {language: {
                use: true,
                country: config
            }});
        }
        //  完整扩展使用
        else{
            this.config = Object.assign(Pretreatment.DEFAULT_CONFIG, config);
        }
    }
    async init(){
        //  获取 设备、用户 信息
        const profile = await getProfile();
        //  获取 LANG
        const LANG = await this.fnLanguageInit();
        //  初始化 sentry
        this.fnSentryInit(profile);

        return {profile, LANG};
    }
    fnSentryInit(profile: Awaited<ReturnType<typeof getProfile>>){
        const {use} = this.config.sentry!;
        const dynamicDsn = window?.ACTIVITY_H5_CONFIG?.fnGetSentryDsn(getQueryString('lang'));
        const isOp = location.href.includes('_op');
        const isBanner = location.href.includes('_banner');
        if(ENV === 'build' && /MICO/i.test(navigator.userAgent) && !isOp && !isBanner && use || getQueryString('sentrySwitch')){
            // 上报数据必有 html 编译信息、入口来源参数。
			const userProfile = {
                h5BuildInfo: fnGetCommentInfo(),
                entrance: getQueryString('entrance'),
            };
            // 通过 JSBridge 获取到用户信息，则扩展上报数据。
            if(profile) {
				const {user, device} = profile;
                Object.assign(userProfile, {
					uid: user.uid,
                    userId: user.userId,
                    country: user.country,
                    appVersion: device.version,
                });
			}
            // Sentry 初始化。
            Sentry.init({
                app: this.app,
                dsn: dynamicDsn,
                initialScope: {
                    user: userProfile
                },
                beforeSend(event: Sentry.Event){
                    if (fnIsLowVersion() || fnIsJsBridgeError(event)) return null;
                    else return event;
                },
                integrations: [Sentry.browserTracingIntegration()],
                tracesSampleRate: 0.2,
            });
        }
    }
    async fnLanguageInit(){
        const {use, country} = this.config.language!;
        if(use){
            return await getLanguage(country);
        }else{
            return '';
        }
    }
}
